import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKlachtOverlastMelden = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F29FC5"
      fillRule="evenodd"
      d="M9 6v24h8l3 4 3-4h8V6z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m22.06 10.58-.32 10.63h-3.48l-.32-10.63zM19.99 26.58c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.27 2.25-2.27 2.27 1.01 2.27 2.27-1.01 2.25-2.27 2.25"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKlachtOverlastMelden);

export default ForwardRef;
